import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import { BiX } from "react-icons/bi";
import { useTranslation } from "react-i18next";

export default function ResourcesPopup({ open, onClose }) {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 560 },
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: "32px 36px",
          direction: isAr ? "rtl" : "ltr",
          outline: "none",
        }}
      >
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <Typography variant="h6" fontWeight={700} color="secondary" sx={{ flex: 1, pr: isAr ? 0 : 2, pl: isAr ? 2 : 0 }}>
            {t("resources_popup.title")}
          </Typography>
          <IconButton onClick={onClose} size="small" sx={{ mt: -0.5 }}>
            <BiX />
          </IconButton>
        </Box>

        {/* Body */}
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8, mb: 3 }}>
          {t("resources_popup.body")}
        </Typography>

        {/* Contact line */}
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8, mb: 3 }}>
          {t("resources_popup.feedback")}{" "}
          <Box
            component="a"
            href="mailto:support@sabeqoon.com"
            sx={{ color: "var(--s-purple-color)", fontWeight: 600, textDecoration: "none" }}
          >
            support@sabeqoon.com
          </Box>
        </Typography>

        {/* Dismiss button */}
        <Box display="flex" justifyContent={isAr ? "flex-start" : "flex-end"}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              borderRadius: "10px",
              fontWeight: 700,
              background: "linear-gradient(135deg, var(--s-purple-dark-color), var(--s-purple-color))",
              "&:hover": { opacity: 0.9 },
            }}
          >
            {t("resources_popup.close")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
